import {AntibodyEnforcedSchemaRole} from 'antibodies/schema-configuration/AntibodyEnforcedDataModelConstants';
import {NamingStrategy} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as net from 'util/Net';

export interface BeginMigrateSchemaInput {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
  preferredNamingStrategies?: Array<NamingStrategy>;
}

export interface BeginMigrateSchemaResponse {
  schemaId: string;
  antibodyRole: AntibodyEnforcedSchemaRole;
}

export function beginMigrateSchema(input: BeginMigrateSchemaInput): Promise<BeginMigrateSchemaResponse> {
  return net.postJSONPromise({
    url: '/1/api/proteins/begin-migrate-schema',
    data: input,
  });
}
